exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-size[data-v-1ae5ad5a] {\n  font-size: 37px;\n}\n.compare-count[data-v-1ae5ad5a] {\n  top: -3px;\n  left: 70%;\n  background: #ff8100;\n  min-width: 16px;\n  min-height: 16px;\n  border-radius: 10px;\n}\n", ""]);

// exports
